<template>
  <v-row justify="center">
    <v-dialog
      v-model="openModal"
      persistent
      max-width="320"
      @keydown.esc="saveRefuseReason(false)"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Motivo do indeferimento
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="reject_reason"
            name="input-7-1"
            filled
            placeholder="Digite o motivo da indeferimento"
            auto-grow
            color="success"
          />
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn
            color="green darken-1"
            text
            @click="saveRefuseReason(false)"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="saveRefuseReason(true)"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  export default {
    name:'DialogRefudeReason',
    data () {
      return {
        reject_reason:'',
        openModal: true,
      }
    },
    methods:{
      saveRefuseReason(status){
        this.$emit('saveRefuseReason',{ 'reject_reason': this.reject_reason, status })
        this.reject_reason = ''
      }
    }
  }
</script>
